import { createContext } from "react";

const DF_LO0011Context = createContext();

export { DF_LO0011Context };
